export interface PtsdFaq {
  q: string;
  a: string;
}

export const ptsdFaqs: PtsdFaq[] = [
  {
    q: "Can a car accident cause PTSD even without severe physical injury?",
    a: "Yes. Post-traumatic stress disorder is triggered by the brain's perception of life threat, extreme terror, or helplessness during the crash. Severe physical injury is not required; psychological trauma alone can lead to persistent PTSD symptoms.",
  },
  {
    q: "How common is PTSD after a motor vehicle accident?",
    a: "Research indicates that motor vehicle collisions are one of the leading civilian causes of PTSD. Published clinical studies estimate that between 8% and 46% of car accident survivors develop PTSD, depending on crash severity, prior trauma, and other individual risk factors.",
  },
  {
    q: "What are the earliest warning signs of PTSD after a crash?",
    a: "Early signs include intrusive flashbacks, nightmares about the collision, avoidance of driving or riding in vehicles, hypervigilance (being easily startled or constantly scanning traffic for danger), and emotional numbness or detachment from loved ones.",
  },
  {
    q: "How does PTSD impact physical health?",
    a: "Chronic stress hormone release (cortisol and adrenaline) places long-term strain on the cardiovascular system, contributes to muscle tension and chronic pain syndromes, disrupts gut microbiome balance leading to digestive issues, and causes insomnia that weakens immune function.",
  },
  {
    q: "What evidence-based treatments are available for PTSD?",
    a: "Standard treatments include trauma-focused cognitive behavioral therapy (CBT), Eye Movement Desensitization and Reprocessing (EMDR), exposure therapy, and psychiatric medication management. For individuals who do not find sufficient relief with first-line therapies, advanced interventional options such as IV ketamine infusion therapy and TMS may be evaluated by an interventional psychiatrist.",
  },
  {
    q: "When should I see a mental health professional after a car accident?",
    a: "If distress, flashbacks, driving anxiety, insomnia, or intense emotional distress persist for more than one month following the accident, or if symptoms interfere with your ability to drive, work, or care for yourself, you should seek an evaluation promptly.",
  },
];

export const ptsdEarlySigns: string[] = [
  "Re-experiencing the accident through intrusive visual flashes or sounds (glass breaking, tires screeching)",
  "Intense panic when approaching intersections or driving past the crash location",
  "Feeling emotionally disconnected, detached, or unable to experience positive emotions",
];

export const ptsdLongTermSigns: string[] = [
  "Chronic insomnia, persistent nightmares, and waking in a cold sweat",
  "Uncontrolled irritability, angry outbursts, or intense dread about future accidents",
  "Cognitive fog, difficulty concentrating, and impaired memory at work or home",
];

export const ptsdSymptoms: string[] = [
  "Recurrent upsetting memories or nightmares of the crash",
  "Avoidance of driving, highway routes, or riding as a passenger",
  "Persistent negative emotional states, guilt, or detachment",
  "Sleep disturbances, night terrors, and chronic insomnia",
  "Irritability, sudden anger, or emotional volatility",
  "Difficulty concentrating at work or completing daily tasks",
];

export const ptsdTreatmentOptions = [
  {
    title: "Psychotherapy (CBT & PE)",
    desc: "Cognitive Behavioral Therapy (CBT) and Prolonged Exposure (PE) help dismantle catastrophic thought cycles and rebuild confidence behind the wheel.",
  },
  {
    title: "EMDR Therapy",
    desc: "Eye Movement Desensitization and Reprocessing (EMDR) helps the brain reprocess traumatic accident memories so they lose their acute emotional charge.",
  },
  {
    title: "IV Ketamine Therapy",
    desc: "Published clinical research shows rapid reduction in PTSD severity and treatment-resistant depressive symptoms with IV ketamine under clinical supervision.",
  },
  {
    title: "TMS & SAINT®",
    desc: "For trauma accompanied by major depression that has resisted antidepressants, non-invasive magnetic neuromodulation offers a direct circuit-level approach.",
  },
];

export const ptsdRelatedLinks = [
  {
    to: "/services/ptsd",
    title: "TMS for PTSD",
    desc: "Non-invasive brain stimulation for PTSD and comorbid depression.",
  },
  {
    to: "/services/psychotherapy",
    title: "Trauma Psychotherapy",
    desc: "CBT, EMDR, and licensed clinical counseling in Coral Springs.",
  },
  {
    to: "/when-past-trauma-resurfaces",
    title: "When Past Trauma Resurfaces",
    desc: "Understanding delayed trauma triggers, anxiety, and sleep.",
  },
];
